import React from "react";

const KeyFeatures = () => {
  const features = [
    {
      title: "Dealer Onboarding",
      image: require("../../assets/img/DealerOnboarding.jpg"),
      description: [
        "ROI Calculation",
        "Document Upload",
        "Approval Process",
        "ERP Integration",
      ],
    },
    {
      title: "Order Management",
      image: require("../../assets/img/OrderManagement.jpg"),
      description: [
        "Ordering",
        "Product Image Display",
        "Realtime Inventory Check",
        "Order Status",
      ],
    },
    {
      title: "Performance Metrics",
      image: require("../../assets/img/PerformanceMetrics.jpg"),
      description: ["Target vs Achieved", "Software Visibility & Performance"],
    },
    {
      title: "Financial Management",
      image: require("../../assets/img/FinancialManagement.jpg"),
      description: [
        "Credit Limit, Exposure, Ledger, Overdue",
        "Credit/Debit Notes, Invoice PDF Output",
      ],
    },
    {
      title: "ERP Integration",
      image: require("../../assets/img/ERPIntegration.jpg"),
      description: ["SAP & NAV Integration"],
    },
    {
      title: "Customer Interaction",
      image: require("../../assets/img/CustomerInteraction.jpg"),
      description: ["Enquiry Management", "Feedback, Complaints & Survey"],
    },
    {
      title: "Pricing",
      image: require("../../assets/img/Pricing01.jpg"),
      description: ["Dynamic Price List"],
    },
  ];

  return (
    <div className="bg-gradient-to-b from-white to-blue-50 py-12 px-4 sm:px-12 background-gradient background-gradient-2">
      <h2 className="text-center text-4xl font-bold text-gray-800 mb-8">
        Key Features of DMS (Primary Sales)
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {features.map((feature, index) => (
          <div
            key={index}
            className="relative bg-white rounded-xl shadow-md overflow-hidden transform transition-transform duration-800 hover:bg-white group"
          >
            {/* Image */}
            <div className="relative w-full h-64">
              <img
                src={feature.image}
                alt={feature.title}
                className="absolute top-0 left-0 w-full h-full object-cover"
              />
            </div>

            {/* Text Content with Arrow */}
            <div className="relative p-4 text-center bg-white group-hover:translate-y-[-10px] transition-transform duration-500">
              <div className="absolute top-[-10px] left-1/2 transform -translate-x-1/2">
                <div className="w-0 h-0 border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent border-b-[10px] border-b-white relative">
                  {/* Inner Outline */}
                  <div className="absolute w-0 h-0 border-l-[8px] border-l-transparent border-r-[8px] border-r-transparent border-b-[6px] border-b-[#0D89C8] top-[6px] left-[-8px]"></div>
                </div>
              </div>
              <h3 className="text-gray-800 text-2xl font-bold group-hover:text-[#0D89C8]">
                {feature.title}
              </h3>
            </div>

            {/* Hover Content */}
            <div className="absolute inset-0 bg-white text-gray-800 flex flex-col items-start opacity-0 group-hover:opacity-100 transition-opacity transition-translate-y duration-1000 p-6">
              <h5 className="text-2xl text-[#0D89C8] font-bold mb-3">
                {feature.title}
              </h5>
              <ul className="list-none space-y-2">
                {feature.description.map((item, idx) => (
                  <li key={idx} className="text-md font-medium">
                    &#8226; {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default KeyFeatures;
